import styles from './fitness.module.css';

const PHRASES = ['LOAD GOES IN', 'FORM COMES OUT', 'FITNESS IS SLOW', 'FATIGUE IS FAST', 'REST IS TRAINING'];

export function Ticker() {
  return (
    <div className={styles.ticker} aria-hidden="true">
      <div className={styles.tickerTrack}>
        {[...PHRASES, ...PHRASES].map((phrase, index) => (
          <span key={`${phrase}-${index}`}>✳&nbsp;&nbsp;{phrase}</span>
        ))}
      </div>
    </div>
  );
}
